var render = function render(){
  var _vm$item, _vm$item$article, _vm$item2, _vm$item2$article, _vm$item3, _vm$item3$article, _vm$item4, _vm$item4$article, _vm$item5, _vm$item5$article, _vm$item6, _vm$item6$article, _vm$item7, _vm$item7$article;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-content"
  }, [_c('PageHeader', {
    attrs: {
      "pageHeaderBackgroundImageSrc": (_vm$item = _vm.item) === null || _vm$item === void 0 ? void 0 : (_vm$item$article = _vm$item.article) === null || _vm$item$article === void 0 ? void 0 : _vm$item$article.largeImageURL,
      "hasOverlay": true,
      "headerBackgroundOpacity": 0.7
    }
  }, [_c('PageHeaderTitleContent', [_c('TitleTextContent', {
    attrs: {
      "titleText": (_vm$item2 = _vm.item) === null || _vm$item2 === void 0 ? void 0 : (_vm$item2$article = _vm$item2.article) === null || _vm$item2$article === void 0 ? void 0 : _vm$item2$article.title
    }
  }), _c('div', {
    staticClass: "d-flex justify-content-center mt-3",
    staticStyle: {
      "min-width": "400px",
      "width": "500px"
    }
  }, [_c('div', {
    staticClass: "w-100 d-flex flex-column flex-md-row flex-lg-row flex-xl-row align-items-center justify-content-center justify-content-md-between justify-content-lg-between justify-content-xl-between"
  }, [_vm.newsPage ? _c('router-link', {
    staticClass: "mb-2 mb-md-0 mb-lg-0 mb-xl-0 mr-md-2 mr-lg-3 mr-xl-3",
    attrs: {
      "to": {
        name: String(_vm.isRecentNews) == 'true' ? 'news' : 'newsArchives',
        query: {
          newsPage: _vm.newsPage,
          query: _vm.query
        }
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "large": "",
      "dark": "",
      "color": '#424EC4'
    }
  }, [_vm._v(" " + _vm._s(String(_vm.isRecentNews) == 'true' ? "Read All Recent News" : "Read All News Archive") + " ")])], 1) : _c('router-link', {
    staticClass: "mb-2 mb-md-0 mb-lg-0 mb-xl-0 mr-md-2 mr-lg-3 mr-xl-3",
    attrs: {
      "to": {
        name: 'cybercorner'
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "large": "",
      "dark": "",
      "color": '#424EC4'
    }
  }, [_vm._v(" Back to Cyber Corner ")])], 1), _c('a', {
    staticClass: "mt-2 mt-md-0 mt-lg-0 mt-xl-0 ml-md-2 ml-lg-3 ml-xl-3",
    attrs: {
      "href": _vm.isUrlValid((_vm$item3 = _vm.item) === null || _vm$item3 === void 0 ? void 0 : (_vm$item3$article = _vm$item3.article) === null || _vm$item3$article === void 0 ? void 0 : _vm$item3$article.detailsURL) ? (_vm$item4 = _vm.item) === null || _vm$item4 === void 0 ? void 0 : (_vm$item4$article = _vm$item4.article) === null || _vm$item4$article === void 0 ? void 0 : _vm$item4$article.detailsURL : '/#/',
      "variant": "link",
      "target": "_blank"
    }
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "large": "",
      "dark": "",
      "color": '#424EC4'
    }
  }, [_vm._v(" Go To Article Source ")])], 1)], 1)])], 1)], 1), _c('b-modal', {
    ref: "my-like-modal",
    attrs: {
      "size": "lg",
      "hide-footer": "",
      "centered": "",
      "title": "Want to Like this post?"
    }
  }, [_c('p', {
    staticClass: "my-1"
  }, [_vm._v(" Please "), _c('router-link', {
    attrs: {
      "to": {
        name: 'login',
        query: {
          redirect: this.$route.path,
          queryString: this.queryString,
          queryValue: this.queryValue
        }
      }
    }
  }, [_c('a', [_vm._v("LOGIN")])]), _vm._v(" or "), _c('router-link', {
    attrs: {
      "to": {
        name: 'signup'
      }
    }
  }, [_c('a', [_vm._v("SIGN UP")])]), _vm._v(" to like content. ")], 1)]), _c('b-modal', {
    ref: "my-modal",
    attrs: {
      "size": "lg",
      "hide-footer": "",
      "centered": "",
      "title": "Want to bookmark this for later?"
    }
  }, [_c('p', {
    staticClass: "my-4"
  }, [_vm._v(" Please "), _c('router-link', {
    attrs: {
      "to": {
        name: 'login',
        query: {
          redirect: this.$route.path,
          queryString: this.queryString,
          queryValue: this.queryValue
        }
      }
    }
  }, [_c('a', [_vm._v("LOGIN")])]), _vm._v(" or "), _c('router-link', {
    attrs: {
      "to": {
        name: 'signup'
      }
    }
  }, [_c('a', [_vm._v("SIGN UP")])]), _vm._v(" to bookmark content. ")], 1)]), _c('SocialMediaWidgets', {
    attrs: {
      "title": _vm.title,
      "description": _vm.description,
      "type": 'blogs-top',
      "isSocialMediaSiblingsVisible": true
    }
  }, [_c('div', {
    staticClass: "col-3 p-0 d-flex align-items-center"
  }, [_c('p', {
    staticClass: "post-snippet text-start text-md-left text-lg-left text-xl-left"
  }, [_vm._v(_vm._s(_vm.getFormattedDate((_vm$item5 = _vm.item) === null || _vm$item5 === void 0 ? void 0 : (_vm$item5$article = _vm$item5.article) === null || _vm$item5$article === void 0 ? void 0 : _vm$item5$article.date)))])])]), _c('section', {
    staticClass: "section-content"
  }, [_c('div', {
    staticClass: "container my-3 px-3 px-md-0 px-lg-0 px-xl-0"
  }, [_c('p', {
    staticClass: "mb-3"
  }, [_c('strong', [_vm._v(_vm._s((_vm$item6 = _vm.item) === null || _vm$item6 === void 0 ? void 0 : (_vm$item6$article = _vm$item6.article) === null || _vm$item6$article === void 0 ? void 0 : _vm$item6$article.headLine))])]), _c('span', {
    attrs: {
      "id": "article-summary"
    },
    domProps: {
      "innerHTML": _vm._s((_vm$item7 = _vm.item) === null || _vm$item7 === void 0 ? void 0 : (_vm$item7$article = _vm$item7.article) === null || _vm$item7$article === void 0 ? void 0 : _vm$item7$article.summary)
    }
  })])]), _c('SocialMediaWidgets', {
    attrs: {
      "title": _vm.title,
      "description": _vm.description,
      "type": 'blogs-bottom',
      "isSocialMediaSiblingsVisible": true,
      "hasBottomMargin": true,
      "socialShareColumnClass": 'col-12',
      "socialShareFlexJustifyClass": _vm.socialMediaFlexJustify
    }
  }, [_c('div', {
    staticClass: "col-12 col-lg-9 col-xl-9 p-0 d-flex flex-row justify-content-center justify-content-lg-start justify-content-xl-start"
  }, [_c('div', {
    staticClass: "d-flex flex-row justify-content-between",
    style: {
      'width': _vm.bottomRowLikesBookmarksWidth
    }
  }, [_c('div', {
    staticClass: "mr-4",
    on: {
      "click": function ($event) {
        return _vm.initiateLike();
      }
    }
  }, [this.liked === false ? _c('FlatIconButton', {
    attrs: {
      "label": "Like",
      "icon": "mdi mdi-thumb-up-outline"
    }
  }) : _vm._e(), this.liked === true ? _c('FlatIconButton', {
    attrs: {
      "label": "Liked",
      "icon": "mdi mdi-thumb-up"
    }
  }) : _vm._e()], 1), _c('p', {
    staticClass: "social-button-area-left-text"
  }, [_c('span', {
    staticClass: "mr-4"
  }, [_vm._v(_vm._s(_vm.likeText))])]), !_vm.isPageBookmarked ? _c('div', {
    staticClass: "pl-1 bookmark-page",
    on: {
      "click": _vm.onBookmarkPage
    }
  }, [_c('div', {
    attrs: {
      "id": "tooltip-bookmark"
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": ['far', 'bookmark']
    }
  }), _vm._v(" Bookmark ")], 1), _c('b-tooltip', {
    attrs: {
      "variant": "primary",
      "target": "tooltip-bookmark"
    }
  }, [_vm._v("Click to bookmark page")])], 1) : _c('div', {
    staticClass: "pl-1 bookmark-page",
    on: {
      "click": _vm.onBookmarkPage
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "id": "tooltip-bookmark",
      "icon": ['fas', 'bookmark']
    }
  }), _vm._v(" Bookmarked "), _c('b-tooltip', {
    attrs: {
      "variant": "success",
      "target": "tooltip-bookmark"
    }
  }, [_vm._v("Bookmarked!")])], 1)])])]), _c('section', {
    staticClass: "section-content"
  }, [_c('div', {
    staticClass: "container mb-5 my-3 px-3 px-md-0 px-lg-0 px-xl-0"
  }, [_c('div', {
    staticClass: "row m-0 mt-4"
  }, [_c('div', {
    staticClass: "col-12 col-md-6 col-lg-6 col-xl-6 p-0 mb-2 mb-md-0 mb-lg-0 mb-xl-0 d-flex justify-content-center justify-content-md-start justify-content-lg-start justify-content-xl-start"
  }, [_vm.previousNewsItemId ? _c('v-btn', {
    attrs: {
      "rounded": "",
      "large": "",
      "dark": "",
      "color": '#424EC4',
      "width": "240"
    },
    on: {
      "click": function () {
        return _vm.goToPreviousOrNextBlogItem(_vm.previousNewsItemId, '#/newsdetail');
      }
    }
  }, [_vm._v(" Read Previous Article ")]) : _vm._e()], 1), _c('div', {
    staticClass: "col-12 col-md-6 col-lg-6 col-xl-6 p-0 mt-2 mt-md-0 mt-lg-0 mt-xl-0 d-flex justify-content-center justify-content-md-end justify-content-lg-end justify-content-xl-end"
  }, [_vm.nextNewsItemId ? _c('v-btn', {
    attrs: {
      "rounded": "",
      "large": "",
      "dark": "",
      "color": '#424EC4',
      "width": "240"
    },
    on: {
      "click": function () {
        return _vm.goToPreviousOrNextBlogItem(_vm.nextNewsItemId, '#/newsdetail');
      }
    }
  }, [_vm._v(" Read Next Article ")]) : _vm._e()], 1)])])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }